import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { DropDownRowViewImpl } from './dropdownrowview';
import { DropDownRowCSSStyle } from './dropdownrowcss';
import { DropDownDto } from '../../../../core/dto/dropdown/dropdowndto';
import { BaseContext } from '../../../../utils/basecontext';

export interface DropDownRowComponentProps extends UIComponentProps
{
    dropDownDto:DropDownDto;
    position: number;
    isImageRequired:boolean;
    isLastIndex: boolean;
    cssStyle:DropDownRowCSSStyle;
    onRowSelected(dropDownDto:DropDownDto):void;
}

export interface DropDownRowComponentState extends UIComponentState
{
    isEnabled:boolean;
}
export interface DropDownRowComponentHandler extends UIComponentHandler
{
    onMouseEnter():void;
    onMouseExit():void;
    onRowSelected():void;
}

export class DropDownRowComponent extends UIComponentImpl<DropDownRowComponentProps, DropDownRowComponentState, UIDataModel> 
implements DropDownRowComponentHandler
{
    constructor(props: DropDownRowComponentProps)
    {
        super(props);
        this.state = {isEnabled:false};
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DropDownRowViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.cssStyle;
    }
    
    onMouseEnter(): void {
        this.setState({isEnabled: true});
    }
    onMouseExit(): void {
        this.setState({isEnabled: false});
    }

   onRowSelected():void
   {
      this.props.onRowSelected(this.props.dropDownDto);
   }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownrowcomponent.tsx